import { MainV3ApiBase } from './base';
import { UserPreference } from '../../mainv2/types/user';

export const UserPreferenceApis = {
  update(diff: Partial<UserPreference>): Promise<UserPreference> {
    return MainV3ApiBase.appendPath('users/current/preference').put(diff);
  },
};
